import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as CheckCircle } from 'assets/images/check-circle-fine.svg';

export const CheckCircleIcon = styled(CheckCircle)`
  width: 21px;
  color: ${ColorPalette.HEX.GreenPigment};
  margin: 32px 24px 0;
`;
